var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInnerHeroLogoDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398,
    height: 587
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-hero-logo-desktop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4757",
    transform: "translate(0 132)",
    fill: "#fff",
    d: "M0 0h398v587H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 72",
    transform: "translate(0 -132)",
    clipPath: "url(#inner-hero-logo-desktop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M-85.698 789.999l-234.134-405.532L85.697 150.335l81.967 141.971-40.778 23.543-58.424-101.192-323.973 187.046 187.05 323.98 323.973-187.046-53.582-92.807-126.204-33.816 12.189-45.49 135.62 36.343 9.458 2.58 86.845 150.42z",
    fill: "#fff",
    opacity: 0.086
  }))));
}

export default __webpack_public_path__ + "edea9135dfc1f406aa49044f365d0e52.svg";
export { SvgInnerHeroLogoDesktop as ReactComponent };